import React from 'react';

import { mdiAlertCircle } from '@lumapps/lumx/icons';
import { Alignment, ColorPalette, ColorVariant, GenericBlock, Icon, Size, Text, Typography } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

export interface NavigationNodeDetailsErrorProps {
    title?: string;
    icon?: string;
    description?: string;
}

/** Error state of the navigation node details */
export const NavigationNodeDetailsError: React.FC<NavigationNodeDetailsErrorProps> = ({
    icon = mdiAlertCircle,
    title,
    description,
}) => {
    const { translateKey } = useTranslate();

    return (
        <GenericBlock wrap={false} gap={Size.big} hAlign={Alignment.center}>
            <GenericBlock.Figure>
                <Icon icon={icon} hasShape size={Size.m} />
            </GenericBlock.Figure>
            <GenericBlock.Content>
                <Text typography={Typography.body2} color={ColorPalette.red} colorVariant={ColorVariant.L1} as="span">
                    {title || translateKey(GLOBAL.GENERIC_ERROR)}
                    <Icon icon={mdiAlertCircle} colorVariant={ColorVariant.N} />
                </Text>
                <Text color={ColorPalette.dark} colorVariant={ColorVariant.L2} as="span">
                    {description || translateKey(GLOBAL.ERROR_WHILE_FETCHING_DATA)}
                </Text>
            </GenericBlock.Content>
        </GenericBlock>
    );
};
